import { FC } from 'react'

import {
  ConfigFormTemplate,
  InputSelectControlField
} from 'Automations/nodeDefinitions/components'
import { ConfigFormProps } from 'Automations/nodeDefinitions/types'
import { useNode } from 'Automations/nodeDefinitions/hooks'
import {
  ReviewType,
  reviewTypeLabel,
  reviewTypeTargetDefinition
} from '../review.types'
import { Config } from './reviewPlaceholder.types'

export const ReviewPlaceholderConfigForm: FC<ConfigFormProps> = ({
  nodeId
}) => {
  const { nodeData, updateNodeType, definition, validationErrors } =
    useNode<Config>({ nodeId })

  if (!nodeData || !definition) return null

  return (
    <ConfigFormTemplate>
      <ConfigFormTemplate.Header nodeId={nodeId} />

      <ConfigFormTemplate.Row label="Review">
        <InputSelectControlField
          data-testid="automations.editor.configForm.review.reviewType"
          placeholder="Select type..."
          options={Object.entries(reviewTypeLabel).map(([value, label]) => ({
            value,
            label
          }))}
          onChange={reviewType => {
            updateNodeType(reviewTypeTargetDefinition[reviewType as ReviewType])
          }}
          validationErrors={validationErrors.reviewType}
        />
      </ConfigFormTemplate.Row>
    </ConfigFormTemplate>
  )
}
